export enum ECaseTaskNames {
  REPRINT_LICENCE = '9a06c929-34cb-4fdb-8eb1-dadf1baba6e1',
}
